import search from "./search";
import rooms from "./rooms";
import guestForm from "./guestForm";

const rules = {
  search,
  rooms,
  guestForm,
};

export default rules;
